import React, { forwardRef, useState, useEffect, useRef, useImperativeHandle } from "react";
import "./TargetTest";
import { TARGET_TYPES } from "../../Views/ConstForTestDriveSection";

const Target = forwardRef((props, ref) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [entries, setEntries] = useState(0);
  const [exits, setExits] = useState(0);
  //const [hit, setHit] = useState(false);
  var hit = false;
  const{ 
    hidden, 
    targetSize,
    targetType
  } = props;

  var targetClassName = 'aa-target';
  switch(targetType)
  {
    case TARGET_TYPES.SMILEY:
      targetClassName += ' aa-smiley';
      break;
    default:
      targetClassName += ' aa-circle';
      break;
  }

  // console.debug("Target render: [" + JSON.stringify(props) + "], classname:[" + targetClassName + "]");

  useImperativeHandle(ref, () => ({
    randomizePosition: () => {
      const targetTestContainer = document.getElementById('targetTestContainer');

      const newPosition = {
        x: Math.random() * (targetTestContainer.offsetWidth - targetSize), // Subtract targetSize to keep the target within the parent element
        y: Math.random() * (targetTestContainer.offsetHeight - targetSize), // Subtract targetSize to keep the target within the parent element
      };
      // if whole ui is available to place target
      // code needs to be added to handle detecting clicks not on target outside parent 
      // const newPosition = {
      //   x: (Math.random() * (window.innerWidth - targetSize)) - targetTestContainer.getBoundingClientRect().left, // Subtract targetSize to keep the target within the window
      //   y: (Math.random() * (window.innerHeight - targetSize)) - targetTestContainer.getBoundingClientRect().top, // Subtract targetSize to keep the target within the window
      // };
      console.debug("target position set=[" + newPosition.x.toString() + "," + newPosition.y.toString() + "]");
      setPosition(newPosition);
      setEntries(0);
      setExits(0);
      hit = false;
    },
    getEntries: () => {
      return entries;
    },
    getExits: () => {
      return exits;
    },
    wasHit: () => {
      return hit;
    }
  }));

  const handleTargetClick = () => {
    hit = true;
  };

  const handleMouseEnter = () => {
    setEntries((prev) => prev + 1);
  }

  const handleMouseLeave = () => {
    setExits((prev) => prev + 1);
  }

  return (
    <div
      className={targetClassName}
      style={{ top: position.y, left: position.x, height: targetSize, width: targetSize }}
      onClick={handleTargetClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      hidden={hidden}
    >
    </div>
  );
});

export default Target;